import { useNavigate } from 'react-router-dom';
import { PLAN_LABELS } from '@constants/plans';
import { ROUTING } from '@constants/routing';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { StyledModal } from '@pages/CampaignDetails/styled';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, Button, Typography } from '@mui/material';

interface UpgradeRequiredModalProps {
  feature: string;
  message: string;
  currentUsage?: number;
  limit?: number;
  plan?: string;
  requiredPlan?: string;
}

const UpgradeRequiredModal = NiceModal.create((props: UpgradeRequiredModalProps) => {
  const modal = useModal();
  const navigate = useNavigate();
  const { message, plan, requiredPlan } = props;

  const handleClose = () => {
    modal.resolve(false);
    modal.remove();
  };

  const handleViewPlans = () => {
    modal.resolve(true);
    modal.remove();
    navigate(`/${ROUTING.PRICING}`);
  };

  const currentPlanLabel = PLAN_LABELS[plan ?? 'trial'] ?? plan ?? 'Free';
  const requiredPlanLabel = PLAN_LABELS[requiredPlan ?? 'starter'] ?? requiredPlan ?? 'Starter';

  return (
    <StyledModal open={modal.visible} size="small" onClose={handleClose}>
      <Box padding="32px 40px" textAlign="center">
        <LockOutlinedIcon sx={{ fontSize: 48, color: 'warning.main', mb: 2 }} />
        <Typography variant="h6" mb="8px">
          Upgrade Required
        </Typography>
        <Typography variant="body2" color="text.secondary" mb="16px">
          {message}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 1,
            mb: 3,
            '& .plan-chip': {
              px: 1.5,
              py: 0.5,
              borderRadius: 1,
              fontSize: '0.75rem',
              fontWeight: 600,
            },
          }}
        >
          <Box className="plan-chip" sx={{ bgcolor: 'action.selected' }}>
            Current: {currentPlanLabel}
          </Box>
          <Box className="plan-chip" sx={{ bgcolor: 'primary.main', color: 'primary.contrastText' }}>
            Required: {requiredPlanLabel}
          </Box>
        </Box>
        <Box display="flex" justifyContent="center" gap="12px">
          <Button color="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleViewPlans}>
            View Plans
          </Button>
        </Box>
      </Box>
    </StyledModal>
  );
});

export const UpgradeRequiredModalId = 'UpgradeRequiredModal';

NiceModal.register(UpgradeRequiredModalId, UpgradeRequiredModal);

export { UpgradeRequiredModal };
export type { UpgradeRequiredModalProps };
